export default "__VITE_ASSET__BUt77i0D__"